import { createConnectQueryKey, useMutation } from '@connectrpc/connect-query'
import { useQueryClient } from '@tanstack/react-query'

import { toaster } from '@enechain/ecloud-designsystem'

import { agreeToTerm } from '~/gen/proto/bff/v1/admin-BffAdminService_connectquery'
import { BffAdminService } from '~/gen/proto/bff/v1/admin_pb'

export function useAgreeToTerm(): ReturnType<typeof useMutation> {
  const queryClient = useQueryClient()
  return useMutation(agreeToTerm, {
    onError: (error) => {
      toaster.create({
        title: error.message,
        type: 'error',
      })
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: createConnectQueryKey({
          schema: BffAdminService.method.listPendingTerms,
          cardinality: 'finite',
        }),
      })
    },
  })
}
